import { List as ImmutableList } from 'immutable';
import { SortValues } from '../constants/SortValues';
import { DEAL_GROUPING_SUFFIX, DEFAULT_TABLE_COLUMNS_TO_OVERVIEW_ROW_PROPERTIES_MAP } from '../constants/OverviewTableConstants';
export const sortRows = (rows, sort) => {
  const columnKey = sort.columnKey;
  const columnRowProperty = DEFAULT_TABLE_COLUMNS_TO_OVERVIEW_ROW_PROPERTIES_MAP[columnKey];
  const sortValue = sort.sortValue;
  const isDealGrouping = columnKey.includes(DEAL_GROUPING_SUFFIX);

  // Sorting supports Currency values, numbers and strings
  return rows.sort((a, b) => {
    const trimmedColumnKey = columnKey.substring(0, columnKey.length - DEAL_GROUPING_SUFFIX.length);
    const aColumn = isDealGrouping ? a.dealGroupings[trimmedColumnKey] : a[columnRowProperty];
    const bColumn = isDealGrouping ? b.dealGroupings[trimmedColumnKey] : b[columnRowProperty];
    let aValue = aColumn || 0;
    let bValue = bColumn || 0;
    if (typeof aColumn === 'object') {
      aValue = aColumn.value;
    }
    if (typeof bColumn === 'object') {
      bValue = bColumn.value;
    }
    if (typeof aValue === 'number' && typeof bValue === 'number') {
      if (sortValue === SortValues.ASCENDING) {
        return aValue - bValue;
      } else {
        return bValue - aValue;
      }
    }
    if (sortValue === SortValues.ASCENDING) {
      return aValue < bValue ? -1 : 1;
    } else {
      return aValue < bValue ? 1 : -1;
    }
  });
};
export const divideAndSortRows = (rows, sort) => {
  let teamRows = ImmutableList();
  let userRows = ImmutableList();
  let deactivatedUserRows = ImmutableList();
  rows.forEach(row => {
    if (row.isUser) {
      if (row.isActive) {
        userRows = userRows.push(row);
      } else {
        deactivatedUserRows = deactivatedUserRows.push(row);
      }
    } else {
      teamRows = teamRows.push(row);
    }
  });
  return sortRows(teamRows, sort).concat(sortRows(userRows, sort)).concat(sortRows(deactivatedUserRows, sort));
};